import { useEffect, RefObject } from 'react';

export function useClickOutside(containerRef: RefObject<HTMLElement>, onClickOutside: () => void, ignoreRef?: RefObject<HTMLElement>) {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node;

            if (!containerRef.current) return;

            if (!containerRef.current.contains(target) && !(ignoreRef?.current && ignoreRef.current.contains(target))) {
                onClickOutside();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [containerRef, onClickOutside, ignoreRef]);
}
